<template>
  <div class="archive">
    <Archive/>
  </div>
</template>

<script>
// @ is an alias to /src
import Archive from '@/components/Archive.vue'

export default {
  name: 'ArchivePage',
  components: {
    Archive
  }
}
</script>
